import { memo } from 'react';

import Box from '../Box/Box';
import PressableIcon from '../PressableIcon/PressableIcon';
import { BonanzaLogoProps } from './BonanzaLogo.types';

function BonanzaLogo({ onBonanzaPress, ...props }: BonanzaLogoProps) {
  return (
    <Box flexDirection="row" centerContent {...props}>
      <PressableIcon
        name="BonanzaLogo"
        iconWidth={156}
        iconHeight={40}
        onPress={onBonanzaPress}
      />
    </Box>
  );
}

export default memo(BonanzaLogo);
